import request from '@utils/request'
import { ParamsProps, ReturnType } from './types'

const list = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: 'dashboard',
      method: 'get',
      authorization: true,
      params: args?.params,
      config: {
        showErr: true,
        store: {
          key: args?.state,
          action: 'set',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}
export default { list }
